// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eqmw","newExpiryDate":"styles_newExpiryDate__2zFK9","footer":"styles_footer__3digk"};